export enum EConceptType {
    MRR = 'MRR',
    BOOKING = 'BOOKING',
}
